import { Component, OnInit, HostListener, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TeamService } from '../../../services/team.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { TeamQueueEdit, TeamQueueEditAbstractInformation } from '../../../models/team/team-queue-edit.model';
import { TeamQueueEnqueue } from '../../../models/team/team-queue-enqueue.model';
import { TeamQueueInformation } from '../../../models/team/team-queue-information.model';
import { AlertService } from '../../../services/alert.service';
import { AccountService } from '../../../services/account.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DecisionBottomSheetComponent } from '../../bottom-sheet/decision-bottom-sheet/decision-bottom-sheet.component';
import { ComponentCanDeactivate } from '../../../services/unsaved-changes.guard';
import { Observable } from 'rxjs';
import { ManageQueueEditComponent } from './manage-queue-edit/manage-queue-edit.component';
import { ManageQueueEnqueueComponent } from './manage-queue-enqueue/manage-queue-enqueue.component';
import { ManageQueueInformationComponent } from './manage-queue-information/manage-queue-information.component';
import { ODPProjectWorkflowViewModel } from '../../../models/odpprojectworkflow/odpProjectWorkflow.model';

@Component({
  selector: 'app-manage-queue',
  templateUrl: './manage-queue.component.html',
  styleUrls: ['./manage-queue.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    ManageQueueEditComponent,
    ManageQueueEnqueueComponent,
    ManageQueueInformationComponent    
  ]

})
export class ManageQueueComponent implements OnInit, ComponentCanDeactivate {

  teamId: number;

  teamQueueEdit: TeamQueueEdit;
  teamQueueEnqueue: TeamQueueEnqueue;
  teamQueueInformation: TeamQueueInformation;

  isUpdating: boolean = false;
  editHasUnsavedChanges: boolean = false;

  allowNavigation: Observable<boolean>;

  activeProject: ODPProjectWorkflowViewModel;


  constructor(
    private teamService: TeamService,
    private authService: AuthService,
    private accountService: AccountService,
    private alertService: AlertService,
    private bottomSheet: MatBottomSheet,
    private activeRoute: ActivatedRoute,
    public router: Router
  ) {
    this.teamQueueInformation = new TeamQueueInformation();
    this.teamQueueEdit = new TeamQueueEdit();
    // Initializing
    this.teamQueueEnqueue = {
      maxAbstracts: 0,
      selectedAbstracts: 0
    }
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean | Observable<boolean> {
    if (this.editHasUnsavedChanges)
      return this.bottomSheet.open(DecisionBottomSheetComponent, {
        data: {
          sheetTitle: "Unsaved Changes",
          sheetHtml: "You've made some changes to the queue and haven't saved them. Are you sure you want to leave?"
        }
      }).afterDismissed();

    return true;
  }

  submitQueueChanges() {
    console.log("Submit pressed");
    this.submitQueueSave();
  }

  refreshTeamInfo() {
    this.teamService.getTeamAbstractStatus(this.teamId)
      .subscribe({
        next: (info) => {
        console.log("Refreshed info");
        this.teamQueueInformation = info;
      }, error: (error) => {
          console.log(error);
          this.alertService.showStickyMessage(error);
        }})
  }

  refreshEnqueueInfo() {
    this.teamService.getMaxAbstractGroups(this.teamId, this.activeProject.odpProjectWorkflowId)
      .subscribe({ next: (max) => {
        console.log("Refreshed enqueue");
        this.teamQueueEnqueue.selectedAbstracts = 0;
        this.teamQueueEnqueue.maxAbstracts = max.maxAbstracts;
        console.log(this.teamQueueEnqueue)
      }, error: (error) => {
          console.log(error);
          this.alertService.showStickyMessage(error);
        }});
  }

  refreshQueueInfo() {
    this.isUpdating = true;
    this.alertService.startLoadingMessage();
    this.teamService.getAbstractGroupsByTeam(this.teamId)
      .subscribe({
        next: (queue) => {
        this.alertService.stopLoadingMessage();
        console.log("Refreshed queue");

        if (queue.queue.length > 0)
          queue.queue.sort((a, b) => (a.sorting - b.sorting));

        this.teamQueueEdit = queue;

        console.log(queue);

        this.isUpdating = false;
      }, error: (error) => {
          this.alertService.stopLoadingMessage();
          console.log(error);
          this.alertService.showStickyMessage(error);
          this.isUpdating = false;
        }});
  }

  submitEnqueue() {
    this.isUpdating = true;

    this.alertService.startLoadingMessage();
    this.teamService.enqueueGroupsByTeam(this.teamId, this.activeProject.odpProjectWorkflowId, this.teamQueueEnqueue.selectedAbstracts)
      .subscribe({
        next: (max) => {
        console.log("Enqueued groups")
        this.alertService.stopLoadingMessage();
        this.refreshQueueInfo();

        this.teamQueueEnqueue.selectedAbstracts = 0;
        this.teamQueueEnqueue.maxAbstracts = max.maxAbstracts;
      }, error: (error) => {
          console.log(error);
          this.alertService.showStickyMessage(error);
          this.alertService.stopLoadingMessage();
          this.isUpdating = false;
        }});
  }

  submitQueueSave() {
    this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: "Save Changes",
        sheetHtml: "Are you sure you want to save all changes made to the queue for this team?"
      }
    }).afterDismissed().subscribe(isOk => {
      if (isOk) {
        this.editHasUnsavedChanges = false;
        this.alertService.startLoadingMessage();
        this.isUpdating = true;
        this.teamService.saveTeamQueueChanges(this.teamQueueEdit, this.teamId)
          .subscribe({
            next: (queue) => {
            console.log("Saved team queue changes");

            this.teamQueueEdit = queue;
            this.alertService.stopLoadingMessage();
            this.isUpdating = false;

            location.reload();
          }, error: (error) => {
              console.log(error);
              this.alertService.showStickyMessage(error);
              this.isUpdating = false;
            }});
      }
    });
  }

  displayQueueError(error: string) {
    this.alertService.showMessage(error);
  }

  updateUnsavedChanges(newValue: boolean) {
    this.editHasUnsavedChanges = newValue;
  }

  ngOnInit() {
    if (this.authService.isSessionExpired) {
      console.log(`QUEUE: REDIRECT TO LOGIN`);
      this.router.navigateByUrl("/account/login");
    }

    this.activeProject = this.accountService.GetActiveProject();
    this.teamId = this.activeRoute.snapshot.params['teamId'];

    this.refreshTeamInfo();
    this.refreshEnqueueInfo();
    this.refreshQueueInfo();

  }

  enqueueModelChange(model: TeamQueueEnqueue) {
    console.log("Got TeamQueueEnqueue: ");
    console.log(model);

    
    setTimeout(() => {
      this.refreshTeamInfo();
    }, 500);
  }

  enqueueClick(model: number) {
    console.log("Got Enqueue: ");
    console.log(model);
    this.submitEnqueue();
  }
}
